export default __webpack_public_path__ + "static/custom-titles-11ecee6f67f4187ba8331ece6a4b48f3.mp4";